import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_LoadingPageFrame3va2mhcnct771 as get_LoadingPageFrame } from './LoadingPageFrame.mjs';
import {
  setDefaultKeyykye56baz645 as setDefaultKey,
  addChildspxcpid5g99g as addChild,
} from '../../../../../../kotlin-react/react/ChildrenBuilder.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function LoadingPageFrame(_this__u8e3s4, state, key) {
  key = key === VOID ? null : key;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var component = get_LoadingPageFrame();
  setDefaultKey(_this__u8e3s4, '@rdk/9_4');
  // Inline function 'react.ChildrenBuilder.invoke' call
  var block = ($this$component) => {
    $this$component.state = state;
    var tmp0_safe_receiver = key;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$component.key = tmp0_safe_receiver;
    }
    return Unit_instance;
  };
  addChild(_this__u8e3s4, component, block);
}
//region block: exports
export {
  LoadingPageFrame as LoadingPageFramekinq1a7dkzpq,
};
//endregion

//# sourceMappingURL=LoadingPageFrameKt.mjs.map
